import { Fragment } from "react";
import BoxTitle from "../../../TEMPLATE/components/box/title/BoxTitle";
import { applicantsCitizen } from "../../hardCodeData/DATA";

const Applicants = () => {
  return (
    <Fragment>
      <BoxTitle
        icon={"im im-icon-Business-ManWoman"}
        title={"ΗΛΕΚΤΡΟΝΙΚΗ ΥΠΟΒΟΛΗ ΑΙΤΗΜΑΤΩΝ"}
        infoContext={"info"}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <div style={{ marginTop: 30 }} />
      {applicantsCitizen.map((item, index) => (
        <button
          key={index}
          type={"button"}
          style={{
            width: 200,
            height: 35,
            marginLeft: "calc((100% - 200px ) /2)",
            marginBottom: 10,
            borderRadius: "30px",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => window.open(item.url, "_blank")}
        >
          <span style={{ fontWeight: "600", fontSize: "15px" }}>
            {item.name}
          </span>
        </button>
      ))}
    </Fragment>
  );
};
export default Applicants;
